export default function (props, defaultProps) {
  return Object.assign({}, defaultProps, props);
}
import {} from "../";
